export function wideStepAfterInterpolator(points: [number, number][]): string
{
    let i = 0, p = points[0];
    const n = points.length;
    const path = [p[0], ',', p[1] === Infinity ? '0' : p[1]];

    while(++i < n) {
        // this is a "empty" point, leaved to mark the hole
        if (points[i][1] === Infinity) {
            // continue the line unti the hole
            if (i !== 0) {
                path.push(`H${points[i][0]}`);
            }
            // if any next point start it as a new point
            if (i < n - 1) {
                path.push(`M${points[i + 1][0]},${points[i + 1][1]}`);
            }
        } else {
            // push the horizontal line,
            // then restart a new point since we want disjoint line
            path.push(`H${(p = points[i])[0]}`); //"V${p[1]}"
            path.push(`M${p[0]},${p[1]}`);
        }
    }
    return path.join('');
}